<template>
  <div class="applicant-form">
    <validation-observer ref="validator" v-slot="{ invalid, handleSubmit }" tag="div">
      <t-form @submit.native.prevent="handleSubmit(submit)">
        <t-validation-wrapper
          vid="experience_domain_ids"
          :name="$t('fields.experience_domains')"
          rules="required"
        >
          <ExperienceDomainSelect v-model="form.experience_domain_ids" />
          <p class="text--grey mt-3">
            <em>{{ $t('hints.experience_domains') }}</em>
          </p>
        </t-validation-wrapper>

        <t-validation-wrapper
          vid="last_position"
          :name="$t('fields.last_position')"
          rules="required"
        >
          <t-input v-model="form.last_position" />
        </t-validation-wrapper>

        <t-validation-wrapper
          vid="has_management_experience"
          :name="$t('fields.management_experience')"
          no-label
        >
          <t-switch v-model="form.has_management_experience">
            {{ $t('fields.management_experience') }}
          </t-switch>
        </t-validation-wrapper>

        <t-validation-wrapper vid="skills" :name="$t('fields.skills')">
          <app-multi-input v-model="form.skills" button-label-key="global.actions.add_skill" />
          <p class="text--grey mt-3">
            <em>{{ $t('hints.skills') }}</em>
          </p>
        </t-validation-wrapper>

        <slot name="footer" :invalid="invalid" :loading="loading" />
      </t-form>
    </validation-observer>
  </div>
</template>
<script>
import Vue from 'vue';
import FormBaseMixin from '../../FormBaseMixin';
import Applicant from '~/models/Applicant';
import ExperienceDomainSelect from '~/components/ResourceSelect/ExperienceDomainSelect';
import AppMultiInput from '~/components/AppMultiInput';

export default Vue.extend({
  components: {
    ExperienceDomainSelect,
    AppMultiInput,
  },

  mixins: [FormBaseMixin],

  props: {
    applicant: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    form: null,
  }),

  created() {
    this.form = this.getForm(this.applicant);
  },

  methods: {
    async request(payload) {
      const model = await new Applicant({ id: this.applicant.id, ...payload }).patch();
      this.$emit('updated', model);

      return model;
    },

    getForm(model = null) {
      return {
        experience_domain_ids: model?.experience_domain_ids ?? [],
        last_position: model?.last_position ?? '',
        has_management_experience: model?.has_management_experience ?? false,
        skills: model?.skills ?? [],
      };
    },

    getPayload() {
      return { ...this.form };
    },
  },
});
</script>
